export default {
    path: '/stock-location',
    component: () => import('@/views/stockLocation/index.vue'),
    children: [
        {
            path: 'manage',
            name: 'ManageStockLocation',
            component: () => import('@/views/stockLocation/pages/ManageStockLocation.vue'),
            meta: {
                middleware: [
                    'auth',
                    'developer',
                    'warehouse_manager',
                    'accounting',
                    'accounting_manager'
                ]
            }
        },
        {
            path: 'product',
            name: 'FindProductLocation',
            component: () => import('@/views/stockLocation/pages/FindProductLocation.vue'),
            meta: {
                middleware: [
                    'auth',
                    'developer',
                    'warehouse_manager',
                    'accounting',
                    'accounting_manager'
                ]
            }
        },
        {
            path: 'location-product/:warehouse/:location',
            name: 'LocationProduct',
            component: () => import('@/views/stockLocation/pages/LocationProduct.vue'),
            meta: {
                middleware: [
                    'auth',
                    'developer',
                    'warehouse_manager',
                    'accounting',
                    'accounting_manager'
                ]
            }
        },
        {
            path: 'create-location',
            name: 'CreateLocation',
            component: () => import('@/views/stockLocation/pages/CreateLocation.vue'),
            meta: {
                middleware: [
                    'auth',
                    'developer',
                    'warehouse_manager',
                    'accounting',
                    'accounting_manager'
                ]
            }
        },
        {
            path: 'print-location',
            name: 'PrintLocation',
            component: () => import('@/views/stockLocation/pages/PrintLocation.vue'),
            meta: {
                middleware: [
                    'auth',
                    'developer',
                    'warehouse_manager',
                    'accounting',
                    'accounting_manager'
                ]
            }
        }
    ]
}
